import React from 'react'
import { IViewErrorResponse } from 'src/app/shared/models/issuedCheckProcessingLog.model'

export const ViewErrorContext = React.createContext<IViewErrorResponse>({
  onJumpToFirst: async () => {},
  onJumpToLast: async () => {},
  onPaginationChange: async (page: number, pageSize: number) => {},
  onPageSizeChange: async (size: number) => {},
  total: 0,
  currentPage: 0,
  pageSize: 1,
  paginationPageSizeSelector: [],
  displayPagination: false,
  getViewErrorDetail: async () => {},
  viewErrorDetail: null,
  isLoading: false
})

export const useViewError = () =>
  React.useContext<IViewErrorResponse>(ViewErrorContext)
